if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  // Sync frame type highlight in sticky sheet from main form's current selection
  window.syncStickyFrameHighlight = function(fieldset) {
    var sel = fieldset.closest('.mb-3')?.querySelector('select');
    var v = '';

    // Find main form's currently selected Frame Type radio
    var mainEl = document.querySelector('.variant-selects-main');
    if (mainEl && sel) {
      var mainRadios = mainEl.querySelectorAll('input[type="radio"]');
      // Try checked + data-value-selected first
      for (var i = 0; i < mainRadios.length; i++) {
        if (mainRadios[i].checked && mainRadios[i].dataset.valueSelected === 'true') {
          for (var j = 0; j < sel.options.length; j++) {
            if (sel.options[j].value === mainRadios[i].value) {
              v = mainRadios[i].value;
              break;
            }
          }
          if (v) break;
        }
      }
      // Fallback: any checked radio matching a Frame Type option
      if (!v) {
        for (var i = 0; i < mainRadios.length; i++) {
          if (mainRadios[i].checked) {
            for (var j = 0; j < sel.options.length; j++) {
              if (sel.options[j].value === mainRadios[i].value) {
                v = mainRadios[i].value;
                break;
              }
            }
          }
          if (v) break;
        }
      }
    }

    // Sync hidden select
    if (v && sel) {
      sel.value = v;
      Array.from(sel.options).forEach(function(o) {
        o.removeAttribute('selected');
        if (o.value === v) o.setAttribute('selected', '');
      });
    } else if (sel) {
      v = sel.value;
    }

    // Update visual highlight
    fieldset.querySelectorAll('.sticky-frame-selected').forEach(function(c) {
      c.classList.remove('sticky-frame-selected');
    });
    if (v) {
      var r = fieldset.querySelector('input[value="' + v + '"]');
      if (r && r.nextElementSibling) {
        r.nextElementSibling.classList.add('sticky-frame-selected');
      }
    }
  };

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        sheetExpanded: false,
        loadingEls: '',
        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          // price-sticky-{sectionId} is a CLASS in the template, not an id, so the
          // source must be looked up with querySelector (getElementById returns null).
          const source = html.querySelector(`.price-sticky-${sectionId}`);
          if (!source) return;
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}
